export default __webpack_public_path__ + "static/media/DNo.17-4.5bc4bab5.jpg";